// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDeductibleDto } from './IDeductibleDto';
import {
    IDeductibleDtoFromJSON,
    IDeductibleDtoFromJSONTyped,
    IDeductibleDtoToJSON,
    IDeductibleDtoToJSONTyped,
} from './IDeductibleDto';
import type { IProcessingTierLiteDto } from './IProcessingTierLiteDto';
import {
    IProcessingTierLiteDtoFromJSON,
    IProcessingTierLiteDtoFromJSONTyped,
    IProcessingTierLiteDtoToJSON,
    IProcessingTierLiteDtoToJSONTyped,
} from './IProcessingTierLiteDto';

/**
 * 
 * @export
 * @interface IDeductibleTierDto
 */
export interface IDeductibleTierDto {
    /**
     * 
     * @type {number}
     * @memberof IDeductibleTierDto
     */
    family_remaining_to_next_tier?: number;
    /**
     * 
     * @type {string}
     * @memberof IDeductibleTierDto
     */
    family_current_tier?: string;
    /**
     * 
     * @type {number}
     * @memberof IDeductibleTierDto
     */
    health_plan_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IDeductibleTierDto
     */
    health_policy_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IDeductibleTierDto
     */
    health_plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IDeductibleTierDto
     */
    coverage_level?: string;
    /**
     * 
     * @type {Array<IDeductibleDto>}
     * @memberof IDeductibleTierDto
     */
    deductibles?: Array<IDeductibleDto>;
    /**
     * 
     * @type {Array<IProcessingTierLiteDto>}
     * @memberof IDeductibleTierDto
     */
    tiers?: Array<IProcessingTierLiteDto>;
}

/**
 * Check if a given object implements the IDeductibleTierDto interface.
 */
export function instanceOfIDeductibleTierDto(value: object): value is IDeductibleTierDto {
    return true;
}

export function IDeductibleTierDtoFromJSON(json: any): IDeductibleTierDto {
    return IDeductibleTierDtoFromJSONTyped(json, false);
}

export function IDeductibleTierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDeductibleTierDto {
    if (json == null) {
        return json;
    }
    return {
        
        'family_remaining_to_next_tier': json['family_remaining_to_next_tier'] == null ? undefined : json['family_remaining_to_next_tier'],
        'family_current_tier': json['family_current_tier'] == null ? undefined : json['family_current_tier'],
        'health_plan_id': json['health_plan_id'] == null ? undefined : json['health_plan_id'],
        'health_policy_id': json['health_policy_id'] == null ? undefined : json['health_policy_id'],
        'health_plan_name': json['health_plan_name'] == null ? undefined : json['health_plan_name'],
        'coverage_level': json['coverage_level'] == null ? undefined : json['coverage_level'],
        'deductibles': json['deductibles'] == null ? undefined : ((json['deductibles'] as Array<any>).map(IDeductibleDtoFromJSON)),
        'tiers': json['tiers'] == null ? undefined : ((json['tiers'] as Array<any>).map(IProcessingTierLiteDtoFromJSON)),
    };
}

export function IDeductibleTierDtoToJSON(json: any): IDeductibleTierDto {
    return IDeductibleTierDtoToJSONTyped(json, false);
}

export function IDeductibleTierDtoToJSONTyped(value?: IDeductibleTierDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'family_remaining_to_next_tier': value['family_remaining_to_next_tier'],
        'family_current_tier': value['family_current_tier'],
        'health_plan_id': value['health_plan_id'],
        'health_policy_id': value['health_policy_id'],
        'health_plan_name': value['health_plan_name'],
        'coverage_level': value['coverage_level'],
        'deductibles': value['deductibles'] == null ? undefined : ((value['deductibles'] as Array<any>).map(IDeductibleDtoToJSON)),
        'tiers': value['tiers'] == null ? undefined : ((value['tiers'] as Array<any>).map(IProcessingTierLiteDtoToJSON)),
    };
}

